export default {
      id: "icon--logout-usage",
      viewBox: "0 0 22 24",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--logout-usage",
      toString: function () {
        return this.url;
      }
    }